import { SET_WILL_TASK_LIST_REFRESH } from 'redux/actions/types/appointment';

export const setWillTaskListRefresh = (willTaskListRefresh) => {
    return {
        type: SET_WILL_TASK_LIST_REFRESH,
        payload: willTaskListRefresh
    }
}